
import { Component, Vue } from "vue-property-decorator";
import AttendanceForm from "@/components/AttendanceForm.vue";
import LayoutDefault from "@/components/layout/default/LayoutDefault.vue";
import DateRangePicker from "vue2-daterange-picker";
import Multiselect from "vue-multiselect";

@Component({
  components: {
    LayoutDefault,
    DateRangePicker,
    AttendanceForm,
    Multiselect
  }
})
export default class Lead extends Vue {
  private loading: boolean = false;

  private created() { }
  private mounted() { }
}
